"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyTypeInput = instanceOfPropertyTypeInput;
exports.PropertyTypeInputFromJSON = PropertyTypeInputFromJSON;
exports.PropertyTypeInputFromJSONTyped = PropertyTypeInputFromJSONTyped;
exports.PropertyTypeInputToJSON = PropertyTypeInputToJSON;
exports.PropertyTypeInputToJSONTyped = PropertyTypeInputToJSONTyped;
/**
 * Check if a given object implements the PropertyTypeInput interface.
 */
function instanceOfPropertyTypeInput(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function PropertyTypeInputFromJSON(json) {
    return PropertyTypeInputFromJSONTyped(json, false);
}
function PropertyTypeInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
function PropertyTypeInputToJSON(json) {
    return PropertyTypeInputToJSONTyped(json, false);
}
function PropertyTypeInputToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
    };
}
